/*
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-10-11 08:04:04
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-12-04 21:42:53
 * @FilePath: \web\src\utils\global.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// const baseURL = 'http://172.26.116.46:7070/';
const baseURL = 'http://www.shenloon.org.cn/backend/';
const fileServer = 'http://www.shenloon.org.cn/backend/';

export default {
  baseURL,
  fileServer
}
